import { checkIfObjectExists } from '@/utils/checkIfObjectExists';
import { BackArrow } from '@/assets/svgExports/BackArrow';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { CURRENCY_SYMBOL } from 'src/config';
import { useRouter } from 'next/router';

const EmiCardSelection = ({ isMobile = false }) => {
  const router = useRouter();
  const [selectedEmi, setSelectedEmi] = useState('');
  const [selectedAccordion, setSelectedAccordion] = useState(0);

  const { allEmiOptions } = useSelector((state) => ({
    allEmiOptions: state.emiReducer.allEmiOptions,
  }));

  useEffect(() => {
    if (checkIfObjectExists(allEmiOptions)) {
      setSelectedAccordion(0);
      if (checkIfObjectExists(allEmiOptions?.emi_options_for_credit_card)) {
        setSelectedEmi('cc');
      } else if (checkIfObjectExists(allEmiOptions?.emi_options_for_debit_card)) {
        setSelectedEmi('dc');
      }
    }
  }, [allEmiOptions]);

  const setSelectedEmiOnClick = (type) => setSelectedEmi(type);

  const accordionHeaderClick = (type) => {
    if (selectedAccordion === type) setSelectedAccordion(null);
    else setSelectedAccordion(type);
  };

  const emiOptionArr = [
    {
      label: 'Credit Card EMI',
      emiOption: allEmiOptions?.emi_options_for_credit_card ?? {},
      type: 'cc',
    },
    {
      label: 'Debit Card EMI',
      emiOption: allEmiOptions?.emi_options_for_debit_card ?? {},
      type: 'dc',
    },
  ];

  const emiAccordionSystem = () => {
    const specificAccordionData =
      checkIfObjectExists(allEmiOptions) && selectedEmi && selectedEmi === 'cc'
        ? allEmiOptions?.emi_options_for_credit_card
        : allEmiOptions?.emi_options_for_debit_card;

    return (
      <div className="accordion">
        {Object.keys(specificAccordionData ?? {})?.length
          ? Object.keys(specificAccordionData ?? {})?.map((acc, index) => {
              return (
                <div className="accordion-item" key={acc}>
                  <div
                    className="accordion__header flex items-center justify-between pointer"
                    onClick={() => accordionHeaderClick(index)}
                  >
                    <span className="accordion__header--title">{acc} Bank</span>
                    <span>
                      <img
                        style={{
                          transform:
                            selectedAccordion === index
                              ? `rotate(180deg)`
                              : `rotate(0deg)`,
                        }}
                        src={'/assets/images/down-arrow-thin.svg'}
                        alt="dropdown button"
                      />
                    </span>
                  </div>
                  {selectedAccordion === index && (
                    <div className="accordion__body">
                      <table className="emi-table">
                        <thead>
                          <tr>
                            <th>EMI Plan</th>
                            <th>Interest (pa)</th>
                            <th>Total Cost</th>
                          </tr>
                        </thead>
                        <tbody>
                          {specificAccordionData[acc]?.map((data) => (
                            <tr key={JSON.stringify(data)}>
                              <td>
                                <b>
                                  {CURRENCY_SYMBOL}
                                  {data.payable_emi_value}
                                </b>{' '}
                                X {data.tenure}
                              </td>
                              <td>
                                {CURRENCY_SYMBOL}
                                {data.monthly_emi_amount} ({data.emi_bank_interest}%)
                              </td>
                              <td>
                                {CURRENCY_SYMBOL}
                                {data.total_payable_amount}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>
              );
            })
          : null}
      </div>
    );
  };

  return (
    <div className="emiSelection">
      {isMobile && (
        <div className="page-header flex items-center">
          <BackArrow onClick={() => router.back()} />
          <span className="header-text ml3 fw6">EMI Options</span>
        </div>
      )}
      <div className="emiSelection__header">
        {emiOptionArr?.map((emi) =>
          checkIfObjectExists(emi.emiOption) ? (
            <span
              key={emi.type}
              onClick={() => setSelectedEmiOnClick(emi.type)}
              className={`emiSelection__header--item relative ${
                selectedEmi === emi.type ? 'active' : ''
              }`}
            >
              {emi.label}
              {selectedEmi === emi.type && <span className="active-banner"></span>}
            </span>
          ) : null
        )}
      </div>
      <div className="emiSelection__body">
        <div className="center emiSelection__body--inner">{emiAccordionSystem()}</div>
      </div>
    </div>
  );
};

export default EmiCardSelection;
